import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {TextButton} from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"

const SkipForNowWrapper = styled.span`
  margin-top: 10px;
  align-self: center;
  color: ${greys.mediumDark};
`

class SkipForNow extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    id: "skipForNow"
  }

  render() {
    const {onClick} = this.props
    return (
      <SkipForNowWrapper>
        <TextButton id={id("button", this.props)} onClick={onClick}>
          <FormattedMessage id="recognition.onboarding.buttons.skip" />
        </TextButton>
      </SkipForNowWrapper>
    )
  }
}

export default SkipForNow
